<template>
  <el-dialog v-on="$listeners" v-bind="$attrs" width="6.8rem">
    <div class="iptBox">
      <h3>Acceso</h3>
      <div class="phoneBox">
        <p>+51</p>
        <el-input
          v-model="loginInfo.loginUser"
          placeholder="Número de 9 dígitos"
          maxLength="9"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        ></el-input>
      </div>
      <div class="codeBox">
        <el-input
          v-model="loginInfo.auth_code"
          placeholder="Introduzca el código"
          maxLength="4"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        ></el-input>
        <el-button @click="getCodeBtn(1)" :disabled="sendStatus">
          {{ sendStatus ? codeCountdown + " S" : "Enviar" }}
        </el-button>
      </div>
      <p class="titleText">
        También se puede probar otras formas o contactar directamente con el
        servicio de atención al cliente
      </p>
      <div class="otherContact">
        <div @click="getCodeBtn(3)">
          <img src="../../assets/images/playPhone.png" alt="" />
          <p>Obtención por teléfono</p>
        </div>
        <div @click="getCodeBtn(4)">
          <img src="../../assets/images/whatsappIcon.png" alt="" />
          <p>Obtención vía WhatsApp</p>
        </div>
      </div>
      <!-- login Btn -->
      <el-button :loading="loginLoading" class="loaginButton" @click="loginBtn">
        Acceso
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCode, login } from "../../utils/api/h5page.js";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      loginInfo: {
        loginUser: "",
        auth_code: "",
      },
      codeCountdown: 30,
      sendStatus: false,
      timeInterval: null,
      loginLoading: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 登录按钮
    loginBtn() {
      if (!this.loginInfo.loginUser || this.loginInfo.loginUser.length < 9) {
        return this.$message.error(
          "Por favor, introduzca un número de teléfono móvil de 9 dígitos."
        );
      }
      if (!this.loginInfo.auth_code) {
        return this.$message.error(
          "Por favor, introduzca el Código de verificación"
        );
      }
      if (this.loginInfo.auth_code.length !== 4) {
        return this.$message.error(
          "Introduzca el Código de verificación de 4 dígitos"
        );
      }

      const params = {
        ...this.loginInfo,
        userType: 1,
        firebase_id: "",
        notice_switch: 0,
        loginUser: "+51" + this.loginInfo.loginUser,
      };

      this.$emit("openLoading");
      this.loginLoading = true;
      // 登录
      login(params).then(({ data }) => {
        if (data.code == 0) {
          localStorage.setItem("token", data.data.access_token);
          localStorage.setItem("loginUser", "+51 " + this.loginInfo.loginUser);
          this.$store.commit("setToken", data.data.access_token);
          this.$message.success("Login successful");
          this.$emit("closeDialog");
          this.$emit("getCurrentNum");
          this.$emit("getUserInformation");
          this.loginLoading = false;
        } else {
          this.$emit("closeLoading");
          this.loginLoading = false;
        }
      });
    },

    // send code
    getCodeBtn(userType) {
      if (!this.loginInfo.loginUser || this.loginInfo.loginUser.length < 9)
        return this.$message.error("Número de 9 dígitos");
      if (this.sendStatus) {
        return this.$message.error("El código de verificación ha sido enviado");
      }
      this.sendStatus = true;
      this.timeInterval = setInterval(() => {
        if (this.codeCountdown == 1) {
          clearInterval(this.timeInterval);

          this.codeCountdown = 30;
          this.sendStatus = false;
          return;
        }
        this.codeCountdown--;
      }, 1000);
      const params = {
        loginUser: "+51" + this.loginInfo.loginUser,
        userType,
        verifyCodeType: 8,
      };
      // 接口
      getCode(params).then(({ data }) => {
        if (data.code !== 0) {
          clearInterval(this.timeInterval);
          this.codeCountdown = 30;
          this.sendStatus = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: 0.2rem;
}
/deep/ .el-dialog__body {
  padding: 0.16rem 0.4rem 0.47rem;
}
/deep/ .el-dialog__close {
  font-size: 0.3rem;
}
.iptBox {
  h3 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.3rem;
  }
  /deep/ .el-input__inner {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.24rem;
  }
  .phoneBox {
    position: relative;
    margin-bottom: 0.3rem;
    p {
      position: absolute;
      z-index: 5;
      left: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.24rem;
      color: #333333;
    }
    /deep/ .el-input__inner {
      width: 6rem;
      height: 0.8rem;
      border-radius: 0.1rem;
      border: 0.01rem solid #979797;
      padding-left: 0.8rem !important;
    }
  }

  .codeBox {
    display: flex;
    .el-button {
      width: 1.8rem;
      height: 0.8rem;
      border-radius: 0.1rem;
      border: 0.01rem solid #979797;
      margin-left: 0.26rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.24rem;
      color: #c90000;
    }
    .el-input {
      width: 3.94rem;
    }
    /deep/ .el-input__inner {
      width: 3.94rem;
      height: 0.8rem;
      border-radius: 0.1rem;
      border: 0.01rem solid #979797;
      padding-left: 0.2rem !important;
    }
  }
  .titleText {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.18rem;
    width: 4.45rem;
    color: #333333;
    text-align: center;
    margin: 0.4rem auto 0.3rem;
  }
  .otherContact {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
      p {
        cursor: pointer;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.18rem;
        color: #666666;
        text-decoration: underline;
      }
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
      }
    }
  }

  .loaginButton {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.9rem;
    height: 0.8rem;
    background: #c90000;
    border-radius: 0.4rem;
    margin: 0.7rem auto 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.24rem;
    color: #ffffff;
    &::v-deep .el-icon-loading {
      font-size: 0.4rem;
    }
  }
}
</style>

<style>
.el-message__icon {
  font-size: 0.2rem !important;
}
</style>
